import {NbMenuItem} from '@nebular/theme';
import {PermissionKey} from '@drl/core/auth/permission-key.enum';
import {FontPack} from '@drl/core/enums';
import {TranslateService} from '@ngx-translate/core';

export const patientMenuItem = (translate: TranslateService): NbMenuItem[] => {
  return [
    {
      title: translate.instant('mainMenuPatientLeftMenuLbl'),
      icon: 'chevron-left',
      link: `/main/patients`,
      pathMatch: 'prefix',
      home: true,
      data: {
        permission: '*',
      },
    },
    {
      title: translate.instant('overviewPatientLeftMenuLbl'),
      icon: {icon: 'chart-area', pack: FontPack.FontAwesomeSolid},
      link: `patient-details`,
      home: false,
      data: {
        permission: PermissionKey.ManagePatientDetails,
      },
    },
    {
      title: translate.instant('chatPatientLeftMenuLbl'),
      icon: {icon: 'comments', pack: FontPack.FontAwesomeSolid},
      link: `chat`,
      home: false,
      data: {
        permission: PermissionKey.CanChat,
      },
    },
    {
      title: translate.instant('adherencePatientLeftMenuLbl'),
      icon: {icon: 'chart-pie-alt', pack: FontPack.FontAwesomeSolid},
      link: `adherence`,
      home: false,
      data: {
        permission: PermissionKey.ManagePatientDetails,
      },
    },
    {
      title: translate.instant('alertsPatientLeftMenuLbl'),
      icon: {icon: 'exclamation-triangle', pack: FontPack.FontAwesomeSolid},
      link: `alerts`,
      home: false,
      data: {
        permission: PermissionKey.ViewAlert,
      },
    },
    {
      title: translate.instant('lifeStyleLeftMenuLbl'),
      icon: {icon: 'tasks', pack: FontPack.FontAwesomeSolid},
      link: 'patient-health-tasks',
      home: false,
      data: {
        permission: PermissionKey.ViewPatientHealthTasks,
      },
    },
    {
      title: translate.instant('mentalHealthPatientLeftMenuLbl'),
      icon: {icon: 'smile-beam', pack: FontPack.FontAwesomeSolid},
      link: 'mental-health',
      home: false,
      data: {
        permission: PermissionKey.ViewMentalHealth,
      },
    },
    {
      title: translate.instant('documentsPatientLeftMenuLbl'),
      icon: {icon: 'file', pack: FontPack.FontAwesomeSolid},
      link: `patient-phr`,
      home: false,
      data: {
        permission: PermissionKey.DownloadHealthRecord,
      },
    },

    {
      title: translate.instant('prescriptionPatientLeftMenuLbl'),
      icon: {icon: 'file-prescription', pack: FontPack.FontAwesomeSolid},
      link: `patient-prescriptions`,
      home: false,
      data: {
        permission: PermissionKey.ViewPrescription,
      },
    },
    {
      title: translate.instant('nursingNotesPatientLeftMenuLbl'),
      icon: {icon: 'notes-medical', pack: FontPack.FontAwesomeSolid},
      link: `nursing-notes`,
      home: false,
      data: {
        permission: PermissionKey.ViewPatientNursingNote,
      },
    },
    {
      title: translate.instant('dietNutritionPatientLeftMenuLbl'),
      icon: {icon: 'utensils', pack: FontPack.FontAwesomeSolid},
      link: `diet`,
      home: false,
      data: {
        permission: PermissionKey.ViewFoodLogs,
      },
    },
    {
      title: translate.instant('othersPatientLeftMenuLbl'),
      icon: '',
      link: '',
      home: false,
      data: {
        permission: PermissionKey.NotAllowed,
      },
    },
  ];
};
